import { BaseEntity } from 'yt-ng-framework';


export class RadnoMestoPoslovi extends BaseEntity {

  constructor() { 
    super();
  }

  RadnoMestoID: number=null;
  PosloviID: number=null;

  Deserialize(input:any){
    this.ID = input.ID;
    this.RadnoMestoID = input.RadnoMestoID;
    this.PosloviID = input.PosloviID;
    return this; 
  }

  Serialize(input: RadnoMestoPoslovi){
    return input;
  }

}
